var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('v-card',{staticClass:"middle"},[_c('v-card-title',[_vm._v(_vm._s(_vm.$t("title")))]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t("text"))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }